import React from 'react';
import { useLocation } from 'react-router-dom';
import { useHeaderRightSlot } from '@/contexts/HeaderRightSlotContext';
import { getAuthenticatedHeaderConfig } from '@/layouts/config/headerConfig';
import { Header, HeaderProps } from './Header';

interface AuthenticatedHeaderProps extends Omit<HeaderProps, 'type'> {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Header component for authenticated pages
 * Based on Figma design with logged type
 * Automatically sets title based on current route
 */
const AuthenticatedHeader: React.FC<AuthenticatedHeaderProps> = ({
  className = '',
  back = true,
  size = 'XL',
  compact = false,
  ...props
}) => {
  const location = useLocation();
  const config = getAuthenticatedHeaderConfig(location.pathname);
  const { title, subtitle, showUserInfo, showBalance, useRightSlot = false, back: configBack, backTo } = config;
  const { slot: rightSlot } = useHeaderRightSlot();
  const showBack = configBack !== undefined ? configBack : back;

  return (
    <>
      <Header
        type="logged"
        back={showBack}
        backTo={backTo}
        size={size}
        compact={compact}
        className={className}
        title={title}
        subtitle={subtitle}
        showUserInfo={showUserInfo}
        showBalance={showBalance}
        rightSlot={useRightSlot ? rightSlot : undefined}
        {...props}
      />
    </>
  );
};

export default AuthenticatedHeader;
